<template>
  <form v-on:submit.prevent="saveForm" novalidate>
    <LoaderContent v-if="isLoading" :welcomeMessage="false" />

    <div class="form-row">
      <div
        class="form-group col-12"
        :class="{ 'is-invalid': $v.company.$error }"
      >
        <label :for="'professional-input-company' + _uid"
          ><span>*</span> Empresa</label
        >
        <selectize
          :id="'professional-input-company' + _uid"
          v-model="company"
          :settings="companySettings"
          required
        >
          <option
            :value="company.id"
            v-for="(company, index) in companies"
            :key="index"
          >
            {{ company.name }}
          </option>
        </selectize>
      </div>

      <div
        class="form-group col-12"
        :class="{ 'is-invalid': $v.responsabilities.$error }"
      >
        <label :for="'professional-input-responsabilities' + _uid"
          ><span>*</span> Responsabilidades</label
        >
        <textarea
          class="form-control"
          :id="'professional-input-responsabilities' + _uid"
          rows="5"
          v-model="responsabilities"
          required
        ></textarea>
      </div>

      <div
        class="form-group col-12 col-md-4"
        :class="{ 'is-invalid': $v.role.$error }"
      >
        <label :for="'professional-input-role' + _uid"
          ><span>*</span> Posición</label
        >
        <input
          type="text"
          :id="'professional-input-role' + _uid"
          class="form-control"
          v-model="role"
          required
        />
      </div>

      <div
        class="form-group col-12 col-md-4"
        :class="{ 'is-invalid': $v.level.$error }"
      >
        <label :for="'professional-input-level' + _uid"
          ><span>*</span> Nivel</label
        >
        <selectize
          :id="'professional-input-level' + _uid"
          v-model="level"
          :settings="levelsSettings"
          required
        >
          <option
            :value="level.id"
            v-for="(level, index) in $store.state.domains
              .professional_experience_levels"
            :key="index"
          >
            {{ level.name.includes("Estagiário") ? "Aprendiz" : "" }}
            {{ level.name.includes("Assistente") ? "Asistente" : "" }}
            {{ level.name.includes("Autônomo") ? "Trabajador por cuenta propia" : "" }}
            {{ level.name.includes("Auxiliar") ? "Auxiliar" : "" }}
            {{ level.name.includes("C Level") ? "Ejecutivo" : "" }}
            {{ level.name.includes("Consultor") ? "Consultor" : "" }}
            {{ level.name.includes("Coordenador") ? "Coordinador" : "" }}
            {{ level.name.includes("Diretor") ? "Director" : "" }}
            {{ level.name.includes("Especialista") ? "Especialista" : "" }}
            {{ level.name.includes("Freelancer") ? "Freelancer" : "" }}
            {{ level.name.includes("Gerente") ? "Gerente" : "" }}
            {{ level.name.includes("Jovem Aprendiz") ? "Menor Aprendiz" : "" }}
            {{ level.name.includes("Júnior") ? "Júnior" : "" }}
            {{ level.name.includes("Pleno") ? "Pleno" : "" }}
            {{ level.name.includes("Sênior") ? "Sénior" : "" }}
            {{ level.name.includes("Técnico") ? "Técnico" : "" }}
            {{ level.name.includes("Tecnólogo") ? "Tecnólogo" : "" }}
            {{ level.name.includes("Voluntário") ? "Voluntario" : "" }}
          </option>
        </selectize>
      </div>

      <div
        class="form-group col-12 col-md-4"
        :class="{ 'is-invalid': $v.area.$error }"
      >
        <label :for="'professional-input-area' + _uid"
          ><span>*</span> Área</label
        >
        <selectize
          :id="'professional-input-area' + _uid"
          v-model="area"
          :settings="areasSettings"
          required
        >
          <option
            :value="area.id"
            v-for="(area, index) in $store.state.domains
              .professional_experience_areas"
            :key="index"
          >
            {{ area.name.includes("Voluntário") ? "Voluntario" : "" }}
            {{ area.name.includes("Administrativo") ? "Administrativo" : "" }}
            {{ area.name.includes("Atendimento") ? "Atención al cliente" : "" }}
            {{ area.name.includes("Comunicação") ? "Comunicación" : "" }}
            {{ area.name.includes("Criatividade, Arte e Cultura") ? "Creatividad Arte y Cultura" : "" }}
            {{ area.name.includes("Suprimentos (Compras)") ? "Compras" : "" }}
            {{ area.name.includes("Design") ? "Diseño" : "" }}
            {{ area.name.includes("Educação") ? "Educación" : "" }}
            {{ area.name.includes("Engenharia") ? "Ingeniería" : "" }}
            {{ area.name.includes("Facilities") ? "Instalaciones" : "" }}
            {{ area.name.includes("Finanças") ? "Finanzas" : "" }}
            {{ area.name.includes("Fiscal e Tributária") ? "Fiscal y Tributario" : "" }}
            {{ area.name.includes("Jurídica") ? "Legal" : "" }}
            {{ area.name.includes("Logística e Supply Chain") ? "Logística y Cadena de Suministro" : "" }}
            {{ area.name.includes("Marketing") ? "Marketing" : "" }}
            {{ area.name.includes("Pesquisa e Desenvolvimento") ? "Investigación y Desarrollo" : "" }}
            {{ area.name.includes("Planejamento e Estratégia") ? "Planificación y Estrategia" : "" }}
            {{ area.name.includes("Produção e Fabricação") ? "Producción y Fabricación" : "" }}
            {{ area.name.includes("Produtora") ? "Productor" : "" }}
            {{ area.name.includes("Projetos") ? "Proyectos" : "" }}
            {{ area.name.includes("Qualidade") ? "Calidad" : "" }}
            {{ area.name.includes("Relações Públicas") ? "Relaciones Públicas" : "" }}
            {{ area.name.includes("RH e Desenvolvimento") ? "RRHH" : "" }}
            {{ area.name.includes("Saúde") ? "Salud" : "" }}
            {{ area.name.includes("Serviços") ? "Servicios" : "" }}
            {{ area.name.includes("Sustentabilidade") ? "Sostenibilidad" : "" }}
            {{ area.name.includes("Tecnologia") ? "Tecnología" : "" }}
            {{ area.name.includes("Têxtil e Moda") ? "Textil y Moda" : "" }}
            {{ area.name.includes("Varejo") ? "Minorista" : "" }}
            {{ area.name.includes("Vendas e Comercial") ? "Ventas y Comercial" : "" }}
            {{ area.name.includes("Outros") ? "Otros" : "" }}
            {{ area.name.includes("Franquia") ? "Franquicia" : "" }}
          </option>
        </selectize>
      </div>

      <div
        class="form-group col-6 col-md-4"
        :class="{ 'is-invalid': $v.startYear.$error }"
      >
        <label :for="'professional-input-date-from' + _uid"
          ><span>*</span> En</label
        >
        <the-mask
          type="text"
          :id="'professional-input-date-from' + _uid"
          class="form-control"
          v-model="startYear"
          :mask="'##/####'"
          :masked="true"
          placeholder="Exemplo: 06/2010"
          required
        />
      </div>

      <div
        class="form-group col-6 col-md-4"
        :class="{ 'is-invalid': $v.endYear.$error }"
      >
        <label :for="'professional-input-date-to' + _uid"
          ><span>*</span> Hasta</label
        >
        <the-mask
          type="text"
          :id="'professional-input-date-to' + _uid"
          class="form-control"
          v-model="endYear"
          :mask="'##/####'"
          :masked="true"
          :placeholder="!currentOccupation ? 'Exemplo: 06/2011' : ''"
          :required="!currentOccupation"
          :disabled="currentOccupation"
        />
        <small v-if="endYear.length > 2 && !$v.endYear.isAfterStart"
          >Debe ser posterior a la fecha de inicio</small
        >
      </div>

      <div class="form-group col-12 col-md-4 align-self-end">
        <div class="custom-control custom-checkbox mb-2 w-100">
          <input
            type="checkbox"
            class="custom-control-input"
            :id="'professional-input-current-occupation' + _uid"
            v-model="currentOccupation"
            :value="true"
          />
          <label
            class="custom-control-label"
            :for="'professional-input-current-occupation' + _uid"
            >Mi posición actual</label
          >
        </div>
      </div>
    </div>

    <p class="small text-right font-italic">
      los campos con * son obligatorios.
    </p>

    <div class="d-flex align-items-center mt-4" v-if="hasButtons">
      <button type="reset" class="btn btn-light mr-auto" @click="reset()">
        Cancelar
      </button>
      <button type="submit" class="btn btn-blue-ml">Guardar</button>
    </div>

  </form>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, requiredIf, minValue } from 'vuelidate/lib/validators';
import LoaderContent from '../Loader/LoaderContent.vue';

export default {
  name: 'FormProfessionalExp',

  data() {
    return {
      professional_experience_id: '',
      company: '',
      responsabilities: '',
      role: '',
      level: '',
      area: '',
      startYear: '',
      endYear: '',
      currentOccupation: false,

      companySettings: {
        create: true,
        createOnBlur: true,
        dropdownParent: 'body',
        maxOptions: 10,
        addPrecedence: true,
        onItemAdd: (value) => {
          this.company = value;
        },
        render: {
          option_create(data, escape) {
            return `<div class="create">Adicionar a empresa <strong>${escape(
              data.input,
            )}</strong>&hellip;</div>`;
          },
        },
      },

      levelsSettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: 'body',
      },

      areasSettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: 'body',
      },

      isLoading: false,

      source: 'chatbot',
    };
  },

  computed: {
    companies() {
      return [];
      // return this.$store.state.domains.companies;
    },
  },

  props: {
    hasButtons: {
      type: Boolean,
      default: false,
    },

    hasOnlyButton: {
      type: Boolean,
      default: false,
    },

    storeByEventBus: {
      type: Boolean,
      default: false,
    },

    rawData: {
      default: () => {},
    },
  },

  components: {
    LoaderContent,
  },

  watch: {
    currentOccupation(newValue, oldValue) {
      if (newValue) {
        this.endYear = '';
      }
    },
  },

  mixins: [validationMixin],

  validations: {
    company: { required },

    responsabilities: { required },

    role: { required },

    level: { required },

    area: { required },

    startYear: {
      required,
      isDate: (value, _this) => value.length == 7
        && _this.$moment(`${value.split('/').reverse().join('-')}-01`).isValid(),
    },

    endYear: {
      required: requiredIf(function (value) {
        return this.currentOccupation == false;
      }),
      isDate: (value, _this) => _this.currentOccupation == true
        || (value.length == 7
          && _this
            .$moment(`${value.split('/').reverse().join('-')}-01`)
            .isValid()),
      isAfterStart: (value, _this) => _this.currentOccupation == true
        || (value.length == 7
          && _this
            .$moment(`${value.split('/').reverse().join('-')}-01`)
            .isAfter(`${_this.startYear.split('/').reverse().join('-')}-01`)),
    },
  },

  mounted() {
    this.initListeners();
    this.setRawData();
  },

  destroyed() {
    this.$EventBus.$off('editingProfessionalExp');
  },

  beforeDestroy() {
    this.$store.commit('PROFESSIONAL_EXPERIENCES_FORMS', { _uid: this._uid });
  },

  methods: {
    setRawData() {
      if (this.rawData && typeof this.rawData == 'object') {
        const experience = this.rawData;

        if (experience.companyId == null) {
          this.companies.push({
            id: experience.company,
            name: experience.company,
          });
          this.company = experience.company;
        } else {
          this.company = experience.companyId;
        }
        this.responsabilities = experience.responsabilities;
        this.role = experience.occupations[0].role;
        this.level = experience.occupations[0].level_id || experience.occupations[0].level;
        this.area = experience.occupations[0].area_id || experience.occupations[0].area;
        this.startYear = this.$moment(
          experience.occupations[0].start_year,
        ).format('MM/YYYY');
        this.endYear = this.$moment(experience.occupations[0].end_year).format(
          'MM/YYYY',
        );
        this.currentOccupation = experience.occupations[0].current_occupation;
      }
    },

    initListeners() {
      this.$EventBus.$on('editingProfessionalExp', (experience) => {
        let requestData = '';
        const requestDomainParam = '';
        let requestDomainReturn = '';
        this.isLoading = true;

        if (this.$store.state.domains.companies.length == 0) {
          requestDomainReturn += 'companies {id, name},';
        }

        requestDomainReturn += 'professionalExperienceAreas {id, name},';

        if (
          this.$store.state.domains.professional_experience_levels.length == 0
        ) {
          requestDomainReturn += 'professionalExperienceLevels {id, name}';
        }

        if (requestDomainParam.length > 0 || requestDomainReturn.length > 0) {
          requestData += `domains(${requestDomainParam}){${requestDomainReturn}}`;
        }

        if (!experience) {
          this.reset(false);
        } else {
          this.professional_experience_id = experience.id;

          requestData += `professionalExperience(id: "${experience.id}", userId: ${this.$store.state.user.profile.id}) {
              id,
              responsabilities,
              company,
              companyId,
              role,
              startYear,
              endYear,
              level,
              area,
              currentOccupation
            },`;
        }

        this.$store
          .dispatch('graphql_queries/query', requestData)
          .then((response) => {
            if (response && response.professionalExperience) {
              const experience = response.professionalExperience;

              if (experience.companyId == null) {
                this.companies.push({
                  id: experience.company,
                  name: experience.company,
                });
                this.company = experience.company;
              } else {
                this.company = experience.companyId;
              }
              this.responsabilities = experience.responsabilities;
              this.role = experience.role;
              this.level = experience.level;
              this.area = experience.area;
              this.startYear = this.$moment(experience.startYear).format(
                'MM/YYYY',
              );
              this.endYear = this.$moment(experience.endYear).format('MM/YYYY');
              this.currentOccupation = experience.currentOccupation;
            }

            this.isLoading = false;
          });
      });

      if (this.storeByEventBus) {
        this.$EventBus.$on(
          'storeProfessionalExperienceFormInSequence',
          this.storeForm,
        );
      }
    },

    reset(closeModal = true) {
      this.isLoading = false;
      this.$v.$reset();
      if (closeModal) this.$emit('closeModal');
      Object.assign(this.$data, this.$options.data.call(this));
      this.initListeners();
      this.startYear = '/';
      this.endYear = '/';
    },

    saveForm() {
      this.$v.$touch();

      if (this.$v.$invalid) {
      } else {
        const data = this.$data;

        this.$store
          .dispatch('user/professionalExpCreateUpdate', data)
          .then((response) => {
            if (response.error) {
              this.$swal(
                'Uoops',
                'Se ha producido un error al guardar la información',
                'error',
              );
            } else {
              this.$store
                .dispatch(
                  'graphql_queries/query',
                  `
                user( id: "${this.$store.state.user.profile.id}" ){
                  profile{
                    professionalExperiences {
                      id,
                      role,
                      responsabilities,
                      company,
                      startYear,
                      endYear
                    }
                  }
                }
              `,
                )
                .then((updatedData) => {
                  this.$swal(
                    '¡Hecho!',
                    'Formación guardada con éxito',
                    'success',
                  );
                  this.reset();
                });
            }
          });
      }
    },

    storeForm() {
      if (this._isDestroyed) return;
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.$store.commit('PROFESSIONAL_EXPERIENCES_FORMS', {
          _uid: this._uid,
          error: true,
        });
      } else {
        this.$store.commit(
          'PROFESSIONAL_EXPERIENCES_FORMS',
          Object.assign(this.$data, { _uid: this._uid }),
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
